/**
 * SIP通話ライブラリのステータスコード。
 * iOS CallLibraryStatus.swift と1対1対応。
 * コメント内の数値はiOS側の旧Mincライブラリ互換コード。
 */
export enum CallLibraryStatus {
  cantUse = "cantUse", // Int.min: ライブラリ使用不可
  none = "none", // -1:  IVIOS_NOTIFY_NONE
  wait = "wait", // 0:   IVIOS_NOTIFY_WAIT
  regOk = "regOk", // 100: IVIOS_NOTIFY_REGOK
  regNg = "regNg", // 101: IVIOS_NOTIFY_REGNG
  regAuthFail = "regAuthFail", // 102: IVIOS_NOTIFY_REGAUTHFAIL
  unRegOk = "unRegOk", // 103: IVIOS_NOTIFY_UNREGOK
  unRegNg = "unRegNg", // 104: IVIOS_NOTIFY_UNREGNG
  arrive = "arrive", // 200: IVIOS_NOTIFY_ARRIVE
  ringing = "ringing", // 201: IVIOS_NOTIFY_RINGING
  earlyMedia = "earlyMedia", // 202: IVIOS_NOTIFY_EARLYMEDIA
  notFound = "notFound", // 203: IVIOS_NOTIFY_NOTFOUND
  busy = "busy", // 204: IVIOS_NOTIFY_BUSY
  callFail = "callFail", // 205: IVIOS_NOTIFY_CALLFAIL
  connect = "connect", // 250: IVIOS_NOTIFY_CONNECT
  disconnect = "disconnect", // 251: IVIOS_NOTIFY_DISCONNECT
  callInBusy = "callInBusy", // 260: IVIOS_NOTIFY_CALLINBUSY
  recvPb = "recvPb", // 400: IVIOS_NOTIFY_RECVPB
  holdCliOn = "holdCliOn", // 401: IVIOS_NOTIFY_HOLDCLION
  holdCliOff = "holdCliOff", // 402: IVIOS_NOTIFY_HOLDCLIOFF
  holdCliFail = "holdCliFail", // 403: IVIOS_NOTIFY_HOLDCLIFAIL
  holdSvrOn = "holdSvrOn", // 404: IVIOS_NOTIFY_HOLDSVRON
  holdSvrOff = "holdSvrOff", // 405: IVIOS_NOTIFY_HOLDSVROFF
  holdSvrFail = "holdSvrFail", // 406: IVIOS_NOTIFY_HOLDSVRFAIL
  recvRtpTo = "recvRtpTo", // 408: IVIOS_NOTIFY_RECVRTPTO
  disconnBack = "disconnBack", // 409: IVIOS_NOTIFY_DISCONNBACK
  referCliAbort = "referCliAbort", // 410: IVIOS_NOTIFY_REFER_CLI_ABORT
}

/**
 * 通話終了理由。
 * iOS HangUpReasonType.swift と1対1対応。
 */
export enum HangUpReasonType {
  tappedBackButton = "tappedBackButton", // 戻るボタン押下
  tappedHangUpButton = "tappedHangUpButton", // 電話を切るボタン押下
  callFail = "callFail", // 通話失敗（callFail / busy / 番号誤り）
  other = "other", // 通常切断またはタイマー終了
}

/**
 * SIP.js で使用する通話設定。
 * CallInfoEntity からブラウザ非対応のiOS専用フィールドを除いたサブセット。
 * 除外フィールド: callLibrary / clientPort / audioSessionMode /
 *                audioUnitSubType / samplingRate / buffer / switchBoardGain
 */
export interface SipCallInfo {
  serverAddress: string;
  serverPort: number;
  name: string;
  password: string;
  /** 発信先内線番号。SipManager.call() に渡す。 */
  phoneNumber: string;
  displayName: string;
  /** 自動切断時間（秒）。0 は自動切断なし。 */
  callDisconnectTime: number;
  /** SIP REGISTER の Expires 値（秒）。デフォルト 3600。 */
  expiresValue: number;
  /** 5xx エラー後の再登録待機時間（秒）。デフォルト 60。 */
  secondsRetryAfterFail: number;
  /** SDP の a=ptime（ミリ秒）。デフォルト 20。 */
  ptimeMs: number;
  /** TURN サーバー URL (例: "turn:localhost:3478?transport=tcp")。省略時は TURN 未使用。 */
  turnServerUrl?: string;
  /** TURN 認証ユーザー名 */
  turnUsername?: string;
  /** TURN 認証パスワード */
  turnPassword?: string;
}

/** SipManager のステータス変更を通知するコールバック型 */
export type SipStatusCallback = (status: CallLibraryStatus) => void;
